export const createRepeatValue = (value) => {
  switch (value) {
    case "not_repeat":
      return {
        value: "not_repeat",
        label: "Does not repeat",
      };
    case "minutely":
      return {
        value: "minutely",
        label: "Minutely",
      };
    case "hourly":
      return {
        value: "hourly",
        label: "Hourly",
      };
    case "daily":
      return {
        value: "daily",
        label: "Daily",
      };
    case "weekly":
      return {
        value: "weekly",
        label: "Weekly",
      };
    case "monthly":
      return {
        value: "monthly",
        label: "Monthly",
      };
  }
};
